import {isDevMode} from "../../electron-modules";

export interface AssetStatus {
  filename: string;
  status: string;
}

export const backendHost = isDevMode
  ? "http://127.0.0.1:8000"
  : "https://engine.solv3d.com";

export const frontendHost = isDevMode
  ? "http://127.0.0.1:3001"
  : "https://engine.solv3d.com";